export default {
    campuses:               { method: 'get',    url: 'campuses' },
    campusesFilterAmbience: { method: 'get',    url: 'campuses/filter/ambience' },
    campusesFilterGroup:    { method: 'get',    url: 'campuses/filter/group' },
    campusCreate:           { method: 'post',   url: 'campuses' },
    campusUpdate:           { method: 'put',    url: 'campuses/{id}' },
    campusDelete:           { method: 'delete', url: 'campuses/{id}' },
}